import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57533307"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gacha__body" }
const _hoisted_2 = { class: "gacha__body_inner" }
const _hoisted_3 = { class: "gacha__lever" }
const _hoisted_4 = { class: "gacha__ball" }
const _hoisted_5 = { class: "dropBall" }
const _hoisted_6 = { class: "dropBall__inner" }
const _hoisted_7 = { class: "dropBall__ball" }
const _hoisted_8 = { class: "openBall" }
const _hoisted_9 = { class: "openBook" }
const _hoisted_10 = { class: "openBook__bg" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "openBook__star" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "openBook__item_inner" }

import { withDefaults, ref, toRefs, watch } from 'vue'

// inline svg
import GachaBody from '@/components/GachaAnimation/svg/GachaBody.vue'
import GachaLever from '@/components/GachaAnimation/svg/GachaLever.vue'
import GachaBall from '@/components/GachaAnimation/svg/GachaBall.vue'
import DropBall from '@/components/GachaAnimation/svg/DropBall.vue'
import OpenBallTop from '@/components/GachaAnimation/svg/OpenBallTop.vue'
import OpenBallBottom from '@/components/GachaAnimation/svg/OpenBallBottom.vue'
import OpenBook from '@/components/GachaAnimation/svg/OpenBook.vue'

interface Props {
  start: boolean
  scene: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GachaAnimation',
  props: {
    start: { type: Boolean, default: false },
    scene: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { start: boolean, scene: number }

/**
 * GachaAnimation.
 *
 * ガチャアニメーション.
 */



// アニメーション発火
const move = (oldValue: number, newValue: number, unit: string) => {
  switch (props.start) {
    case true:
      return `${newValue}${unit}`
    default:
      return `${oldValue}${unit}`
  }
}

// 本のパラパラ
const pageNum = ref<number>(0)
const { scene } = toRefs(props)
const bookPageTurn = () => {
  setTimeout(() => {
    pageNum.value++
    if (pageNum.value === 7) {
      pageNum.value = 4
    }
    bookPageTurn()
  }, 30)
}
watch(scene, () => {
  if (scene.value === 2) {
    setTimeout(() => {
      bookPageTurn()
    }, 1800)
  }
})

// ボール配列
const ballArr = [
  {
    fill: '#8DE0A9',
    default: {
      x: -256,
      y: -68,
      rotate: 43,
    },
    move: {
      x: -170,
      y: -190,
      rotate: 120,
    },
  },
  {
    fill: '#60BCF5',
    default: {
      x: -230,
      y: 110,
      rotate: 300,
    },
    move: {
      x: -255,
      y: -35,
      rotate: 180,
    },
  },
  {
    fill: '#FAA54F',
    default: {
      x: -160,
      y: 200,
      rotate: 30,
    },
    move: {
      x: -230,
      y: 130,
      rotate: 30,
    },
  },
  {
    fill: '#EB6E50',
    default: {
      x: -15,
      y: 220,
      rotate: 60,
    },
    move: {
      x: -160,
      y: 200,
      rotate: 200,
    },
  },
  {
    fill: '#FAA54F',
    default: {
      x: 170,
      y: 200,
      rotate: 340,
    },
    move: {
      x: 10,
      y: 220,
      rotate: 170,
    },
  },
  {
    fill: '#FAA54F',
    default: {
      x: -135,
      y: -175,
      rotate: 30,
    },
    move: {
      x: -5,
      y: -215,
      rotate: 140,
    },
  },
  {
    fill: '#F9F247',
    default: {
      x: -5,
      y: -230,
      rotate: -40,
    },
    move: {
      x: 150,
      y: -170,
      rotate: 40,
    },
  },
  {
    fill: '#60BCF5',
    default: {
      x: 140,
      y: -165,
      rotate: 220,
    },
    move: {
      x: 220,
      y: -60,
      rotate: 340,
    },
  },
  {
    fill: '#8DE0A9',
    default: {
      x: 200,
      y: -50,
      rotate: 200,
    },
    move: {
      x: 240,
      y: 85,
      rotate: 120,
    },
  },
  {
    fill: '#F9F247',
    default: {
      x: 260,
      y: 35,
      rotate: 30,
    },
    move: {
      x: 170,
      y: 200,
      rotate: -40,
    },
  },
  {
    fill: '#F9F247',
    default: {
      x: -125,
      y: -15,
      rotate: -30,
    },
    move: {
      x: 15,
      y: -65,
      rotate: -120,
    },
  },
  {
    fill: '#8DE0A9',
    default: {
      x: -45,
      y: 65,
      rotate: 10,
    },
    move: {
      x: -125,
      y: -15,
      rotate: 90,
    },
  },
  {
    fill: '#60BCF5',
    default: {
      x: 115,
      y: 80,
      rotate: 20,
    },
    move: {
      x: -45,
      y: 65,
      rotate: -60,
    },
  },
  {
    fill: '#EB6E50',
    default: {
      x: 20,
      y: -75,
      rotate: 140,
    },
    move: {
      x: 115,
      y: 60,
      rotate: 240,
    },
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gacha", [`anime-${_unref(scene)}`, __props.start ? 'gacha--start' : '']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GachaBody, { class: "gacha__body_svg" }),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(GachaLever, { class: "gacha__lever_svg" })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ballArr, (ball, i) => {
          return _createElementVNode("div", {
            key: `ball-${i}`,
            class: "gacha__ball_svg"
          }, [
            _createVNode(GachaBall, {
              fill: ball.fill,
              style: _normalizeStyle(`transform: translate(${move(
              ball.default.x,
              ball.move.x,
              'px'
            )}, ${move(ball.default.y, ball.move.y, 'px')}) rotate(${move(
              ball.default.rotate,
              ball.move.rotate,
              'deg'
            )});`)
            }, null, 8, ["fill", "style"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(DropBall)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(OpenBallBottom),
      _createVNode(OpenBallTop)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          src: require('@/assets/image/gacha/img_gacha_bg_line.svg'),
          alt: ""
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("img", {
          src: require('@/assets/image/gacha/img_gacha_bg_star1.svg'),
          alt: ""
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["openBook__item", `openBook__page--${pageNum.value}`])
      }, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(OpenBook)
        ])
      ], 2)
    ])
  ], 2))
}
}

})